import { Page } from '@/core/architecture'

import { ArtistMyCollectionsTemplate } from './template'
import { useViewModel } from './viewModel'

export const ArtistMyCollections: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ArtistMyCollectionsTemplate
      state={state}
      onFetchMore={actions.onFetchMore}
    />
  )
}
